import 'slider-fotorama';

